'use client'
import RightAdsPanel from '@/app/[lng]/components/AdsFructidor/RightAdsPanel/RightAdsPanel'
import { useGetRetailNewsSearchQuery } from '@/app/globalRedux/api/searchSlice'
import {
  setRetailNewsFilterOrder,
  setRetailNewsFilterSortOption,
} from '@/app/globalRedux/filter/retail/retailnewsFilter'
import { RootState } from '@/app/globalRedux/store'
import { AdBannerScheduleType } from '@/app/types/adType'
import { NewsFilterOrderType, OrderType } from '@/app/types/constantDataType'
import { NewsSearchResponse } from '@/app/types/newsSearchType'
import SearchResultSort from '@/components/SearchResultSelect'
import { convertNaNToOne } from '@/lib/formatUtils'
import { useParams } from 'next/navigation'
import { useDispatch, useSelector } from 'react-redux'
import RetailTabs from '../../../companies/[[...companyPageNo]]/(components)/RetailTabs'
import RetailNewsPageFilter from './RetailNewsPageFilter'
import RetailNewsResults from './RetailNewsResults'
import RetailNewsFilterTags from './RetailNewstagFilter'

const RetailNewsPageContainer = ({
  adData,
}: {
  adData: AdBannerScheduleType[]
}) => {
  const dispatch = useDispatch()
  const retailNewsFilter = useSelector(
    (state: RootState) => state.retailNewsFilter
  )
  const { newsPageNo } = useParams<{ lng: string; newsPageNo: string[] }>()

  const { data, isLoading, isError } = useGetRetailNewsSearchQuery<{
    data: NewsSearchResponse
    isLoading: boolean
    isError: boolean
  }>({
    retailNewsFilter: retailNewsFilter,
    pageNO: convertNaNToOne(Number(newsPageNo?.[0] || 1)),
  })
  return (
    <div className="flex flex-row gap-7">
      <RetailNewsPageFilter />
      <div className=" flex flex-col">
        <RetailTabs />
        <div className="  flex justify-end mb-2 mt-2">
          <SearchResultSort
            options="NewsSort"
            selectedOption={retailNewsFilter?.retailNewsFilterSortOption}
            sortByFunction={(value) =>
              dispatch(
                setRetailNewsFilterSortOption(value as NewsFilterOrderType)
              )
            }
            order={retailNewsFilter?.retailNewsFilterOrder}
            orderByFunction={(value) => {
              dispatch(setRetailNewsFilterOrder(value as OrderType))
            }}
          />
        </div>
        <RetailNewsFilterTags />
        <RetailNewsResults
          newsData={data}
          isLoading={isLoading || isError}
          adData={adData}
        />
      </div>
      <RightAdsPanel />
    </div>
  )
}

export default RetailNewsPageContainer
